import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  from,
} from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { isDevelopment, isStg } from 'modules/app-config/environment'
import { STG_ENV } from 'modules/app-config/stg-env'
import { getCookieValue } from 'helpers/get-cookie-value'
import pjson from '../../package.json'

const DEV_ENROLLME_GATEWAY_URI =
  'https://enrollmegateway.dev.surecolabs.com/graphql'
const STG_ENROLLME_GATEWAY_URI = STG_ENV.enrollmeGatewayGraphqlUrl
const PROD_ENROLLME_GATEWAY_URI = 'https://enrollmegateway.docday.com/graphql'
const getEnrollmeGatewayUri = () => {
  if (isStg()) {
    return STG_ENROLLME_GATEWAY_URI
  }
  if (isDevelopment()) {
    return DEV_ENROLLME_GATEWAY_URI
  }
  return PROD_ENROLLME_GATEWAY_URI
}
const URI = getEnrollmeGatewayUri()

const httpLink = createHttpLink({
  uri: URI,
})

const DEV_PDF_GRAPH_URI = 'https://pdfservice.dev.surecolabs.com/graphql'
const STG_PDF_GRAPH_URI = `${STG_ENV.pdfServiceUrl}/graphql`
// NOTE: the non-stg/non-dev branch falls back to PROD_ENROLLME_GATEWAY_URI
// (pre-existing: prod PDF graph points at the enrollme gateway). Left as-is.
const getPdfGraphUri = () => {
  if (isStg()) {
    return STG_PDF_GRAPH_URI
  }
  if (isDevelopment()) {
    return DEV_PDF_GRAPH_URI
  }
  return PROD_ENROLLME_GATEWAY_URI
}
const PDF_GRAPH_URI = getPdfGraphUri()

const pdfGraphLink = createHttpLink({
  uri: PDF_GRAPH_URI,
})

const authLink = setContext((_, { headers }) => {
  const sessionVerificationId = getCookieValue('sessionVerificationId')
  const prospectEmail = getCookieValue('prospectEmail')
  const fullToken = localStorage.getItem('admin-token')
  const { idToken } = JSON.parse(fullToken) || {}
  return {
    headers: {
      ...headers,
      authorization: idToken || '',
      'session-verification-id': sessionVerificationId,
      'prospect-email': prospectEmail,
    },
  }
})

const client = new ApolloClient({
  link: from([authLink, httpLink]),
  cache: new InMemoryCache(),
  name: 'enrollme-admin-web',
  version: pjson.version,
})

const pdfGraphClient = new ApolloClient({
  link: from([authLink, pdfGraphLink]),
  cache: new InMemoryCache(),
  name: 'enrollme-admin-web',
  version: pjson.version,
})

export default client
export { pdfGraphClient }
